import { compareTableLabels } from '@components/Gala/seatingSidebar/sidebarModel';
import { AttendeeData } from '../types';

/**
 * Get initials from a full name
 */
export const getInitials = (name: string): string => {
  if (!name) return '';
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};

/**
 * Get unique ticket names from all attendees
 */
export const getUniqueTicketNames = (allTables: any[]): string[] => {
  const ticketNames = new Set<string>();
  
  allTables.forEach(table => {
    table.attendees.forEach((attendee: AttendeeData) => {
      if (attendee.assignedTicket?.name) {
        ticketNames.add(attendee.assignedTicket.name);
      }
    });
  });
  
  return Array.from(ticketNames).sort(compareTableLabels);
};

/**
 * Get table statistics (checked in, not checked in, empty seats)
 */
export const getTableStats = (table: any) => {
  const checkedIn = table.attendees.filter((att: AttendeeData) => att.assignedTicket?.checkedIn === true).length;
  const notCheckedIn = table.attendees.filter((att: AttendeeData) => att.assignedTicket?.checkedIn === false).length;
  const emptySeats = table.capacity - table.attendees.length;
  return { checkedIn, notCheckedIn, emptySeats };
};

/**
 * Normalize table name for comparison
 */
export const normalizeTableName = (name: string) => {
  return name.toLowerCase()
    .replace(/^table\s*/i, '') // Remove 'table' prefix
    .replace(/\s+/g, '')      // Remove all spaces
    .trim();
};

/**
 * Z-index levels for proper element stacking
 */
export const zIndexLevels = {
  background: 100,
  shapes: 200,
  tables: 300,
  text: 400,
  textboxAdvanced: 450,
  attendees: 500
}; 